{
 "tws": [
  4,
  6,
  8,
  10,
  12,
  14,
  16,
  20,
  25
 ],
 "twa": [
  30,
  35,
  40,
  45,
  50,
  55,
  60,
  65,
  70,
  75,
  80,
  85,
  90,
  95,
  100,
  105,
  110,
  115,
  120,
  125,
  130,
  135,
  140,
  145,
  150,
  155,
  160,
  165,
  170,
  175,
  180
 ],
 "speed": [
  [
   1.777,
   2.074,
   2.343,
   2.563,
   2.765,
   2.894,
   3.001,
   3.076,
   3.122,
   3.154,
   3.165,
   3.136,
   3.104,
   3.091,
   3.095,
   3.112,
   3.09,
   3.065,
   3.033,
   2.977,
   2.822,
   2.652,
   2.483,
   2.339,
   2.178,
   2.028,
   1.898,
   1.794,
   1.72,
   1.675,
   1.649
  ],
  [
   2.632,
   3.057,
   3.393,
   3.683,
   3.908,
   4.022,
   4.118,
   4.193,
   4.25,
   4.275,
   4.265,
   4.239,
   4.333,
   4.44,
   4.493,
   4.508,
   4.491,
   4.431,
   4.324,
   4.159,
   3.965,
   3.817,
   3.638,
   3.418,
   3.212,
   3.018,
   2.831,
   2.681,
   2.573,
   2.508,
   2.47
  ],
  [
   3.42,
   3.923,
   4.301,
   4.62,
   4.809,
   4.946,
   5.058,
   5.144,
   5.212,
   5.256,
   5.255,
   5.314,
   5.435,
   5.493,
   5.547,
   5.566,
   5.55,
   5.503,
   5.422,
   5.242,
   5.034,
   4.858,
   4.704,
   4.42,
   4.174,
   3.936,
   3.714,
   3.525,
   3.389,
   3.311,
   3.262
  ],
  [
   4.125,
   4.652,
   5.007,
   5.34,
   5.513,
   5.633,
   5.731,
   5.809,
   5.881,
   5.902,
   5.923,
   6.012,
   6.161,
   6.241,
   6.284,
   6.307,
   6.291,
   6.231,
   6.128,
   5.964,
   5.801,
   5.626,
   5.512,
   5.258,
   5.012,
   4.769,
   4.548,
   4.327,
   4.171,
   4.075,
   4.016
  ],
  [
   4.679,
   5.109,
   5.464,
   5.711,
   5.916,
   6.1,
   6.238,
   6.344,
   6.393,
   6.444,
   6.487,
   6.517,
   6.675,
   6.806,
   6.896,
   6.958,
   6.92,
   6.827,
   6.697,
   6.595,
   6.439,
   6.316,
   6.081,
   5.872,
   5.661,
   5.464,
   5.233,
   5.028,
   4.865,
   4.774,
   4.711
  ],
  [
   4.87,
   5.292,
   5.599,
   5.861,
   6.113,
   6.302,
   6.463,
   6.624,
   6.763,
   6.871,
   6.976,
   7.063,
   7.079,
   7.289,
   7.467,
   7.543,
   7.541,
   7.469,
   7.343,
   7.203,
   7.025,
   6.916,
   6.596,
   6.417,
   6.229,
   6.002,
   5.785,
   5.612,
   5.486,
   5.408,
   5.336
  ],
  [
   4.903,
   5.339,
   5.648,
   5.931,
   6.195,
   6.386,
   6.583,
   6.794,
   7.009,
   7.2,
   7.366,
   7.531,
   7.633,
   7.627,
   7.97,
   8.248,
   8.318,
   8.228,
   8.092,
   7.906,
   7.665,
   7.429,
   7.149,
   6.934,
   6.702,
   6.487,
   6.299,
   6.137,
   5.985,
   5.891,
   5.829
  ],
  [
   4.822,
   5.301,
   5.647,
   5.97,
   6.204,
   6.406,
   6.682,
   6.955,
   7.237,
   7.526,
   7.858,
   8.193,
   8.549,
   8.291,
   8.615,
   9.096,
   9.55,
   9.742,
   10.04,
   9.96,
   9.587,
   9.013,
   8.537,
   8.17,
   7.786,
   7.485,
   7.236,
   7.027,
   6.88,
   6.783,
   6.719
  ],
  [
   4.609,
   5.083,
   5.488,
   5.568,
   5.87,
   6.15,
   6.534,
   6.867,
   7.344,
   7.725,
   8.199,
   8.699,
   9.235,
   9.003,
   9.327,
   9.612,
   9.547,
   9.529,
   9.367,
   9.278,
   8.982,
   8.699,
   8.461,
   8.228,
   7.97,
   7.733,
   7.556,
   7.413,
   7.314,
   7.244,
   7.188
  ]
 ],
 "sails": [
  [
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker"
  ],
  [
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker"
  ],
  [
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker"
  ],
  [
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker"
  ],
  [
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker"
  ],
  [
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker"
  ],
  [
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker"
  ],
  [
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker",
   "spinnaker"
  ],
  [
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib",
   "jib"
  ]
 ],
 "beat": [
  {
   "twa": 44.2,
   "vmg": 1.813,
   "speed": 2.526
  },
  {
   "twa": 42.8,
   "vmg": 2.614,
   "speed": 3.553
  },
  {
   "twa": 41.2,
   "vmg": 3.298,
   "speed": 4.379
  },
  {
   "twa": 39,
   "vmg": 3.837,
   "speed": 4.934
  },
  {
   "twa": 37.5,
   "vmg": 4.204,
   "speed": 5.288
  },
  {
   "twa": 36.1,
   "vmg": 4.339,
   "speed": 5.359
  },
  {
   "twa": 36.2,
   "vmg": 4.378,
   "speed": 5.41
  },
  {
   "twa": 37,
   "vmg": 4.358,
   "speed": 5.443
  },
  {
   "twa": 38.2,
   "vmg": 4.225,
   "speed": 5.339
  }
 ],
 "run": [
  {
   "twa": 144.1,
   "vmg": -1.917,
   "speed": 2.365
  },
  {
   "twa": 144.6,
   "vmg": -2.8,
   "speed": 3.436
  },
  {
   "twa": 146.2,
   "vmg": -3.621,
   "speed": 4.36
  },
  {
   "twa": 150.7,
   "vmg": -4.341,
   "speed": 4.977
  },
  {
   "twa": 155.4,
   "vmg": -4.952,
   "speed": 5.444
  },
  {
   "twa": 157.1,
   "vmg": -5.444,
   "speed": 5.909
  },
  {
   "twa": 163.5,
   "vmg": -5.93,
   "speed": 6.185
  },
  {
   "twa": 160.3,
   "vmg": -6.8,
   "speed": 7.222
  },
  {
   "twa": 174.1,
   "vmg": -7.217,
   "speed": 7.256
  }
 ]
}
